import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';

import { PreSplashComponent } from './pre-splash.component';
import { FlexLayoutModule } from '@ngbracket/ngx-layout';
//import { AnimatorModule } from 'css-animator';

@NgModule({
	declarations: [PreSplashComponent],
	exports: [PreSplashComponent],
	imports: [
		CommonModule,
		MatProgressSpinnerModule,
		FlexLayoutModule
		//AnimatorModule
	]
})
export class PreSplashModule {}
